import * as ngCore from '@angular/core'

import * as content from './content'
import * as overlays from './overlays'

@ngCore.Component({
  imports: [content.Component, overlays.Component],
  selector: 'atn-mosaic-page',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {}
